export function addBill(bill) {
  return { type: "ADD_BILL", bill };
}
export function removeBill(billId) {
  return { type: "REMOVE_BILL", billId };
}
export function setFAQ(payload) {
  return { type: "FAQ", payload };
}

export const clearPersist = () => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN",
      isLogin: false,
    });
    dispatch({
      type: "TOKEN",
      token: false,
    });
  };
};
